import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import { createApp } from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import { invalidateAuthCacheOnBuildChange } from '@/plugins/ability'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

// Create vue app
const app = createApp(App)

const hasInvalidatedStaleAuth = invalidateAuthCacheOnBuildChange()
if (hasInvalidatedStaleAuth) {
  const basePath = import.meta.env.BASE_URL || '/'
  const loginPath = `${basePath.replace(/\/$/, '')}/login`
  const currentPath = window.location.pathname
  if (currentPath !== loginPath) {
    window.location.replace(loginPath)
  }
}

// Register plugins
registerPlugins(app)

// Mount vue app
app.mount('#app')
